// P1-2: the canonical asset counts come from the server, computed once in
// CC_Backend/utils/stats.js and shipped on the collection payload as
// `collection.data.stats`. Nothing in the frontend recomputes them any more —
// three screens each used to derive their own variant, which is why the tiles
// and the exported report disagreed.
//
// Vocabulary (Remediation Plan v2 §3), all scoped to one collection:
//   expected     = matched + unscanned   (the intent list)
//   matched      = on the intent list and collected
//   unscanned    = on the intent list and not collected
//   unexpected   = scanned but not on the intent list
//   totalScanned = everything collected (matched + collected unexpected)
//
// INVARIANT: matched + unscanned === expected

const EMPTY_STATS = {
    expected: 0,
    matched: 0,
    unscanned: 0,
    unexpected: 0,
    totalScanned: 0,
    total: 0,
    byAssetTypeId: {},
};

// The actions/* fetch helpers resolve to `undefined` on a network failure, and
// `data` is null for an unknown collection id — so read defensively and fall
// back to zeros rather than rendering `undefined` in the tiles.
const statsFromCollection = (collection) => collection?.data?.stats ?? EMPTY_STATS;

// The server keys the per-type breakdown by asset_type_id; resolve the names
// with the asset_types list the caller has already loaded.
const statsByTypeName = (stats, assetTypes) => {
    const byTypeId = stats?.byAssetTypeId ?? {};
    const types = Array.isArray(assetTypes) ? assetTypes : [];

    return Object.entries(byTypeId).reduce((acc, [typeId, count]) => {
        const match = types.find(assetType => String(assetType.id) === String(typeId));
        const name = match?.name || 'Unknown';
        acc[name] = (acc[name] || 0) + count;
        return acc;
    }, {});
};

const exports = {
    EMPTY_STATS,
    statsFromCollection,
    statsByTypeName,
};

export default exports;
export {
    EMPTY_STATS,
    statsFromCollection,
    statsByTypeName,
};
